import React, { createContext, useState, useCallback } from "react";

export const SearchContext = createContext(null);

const useSearch = () => {
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
    const [triggerPosition, setTriggerPosition] = useState(null);
    const [inputValue, setInputValue] = useState("");

    const openSearch = useCallback((position = null, inputValue = "") => {
        setTriggerPosition(position);
        setIsMobileSearchOpen(true);
        setInputValue(inputValue);
    }, []);

    const closeSearch = useCallback(() => {
        setIsMobileSearchOpen(false);
        setTriggerPosition(null);
    }, []);


    return {
        isMobileSearchOpen,
        openSearch,
        closeSearch,
        triggerPosition,
        inputValue,
    };
};

const SearchProvider = ({ children }) => {
    const search = useSearch();

    return (
        <SearchContext.Provider value={search}>
            {children}
        </SearchContext.Provider>
    );
};

export default SearchProvider;
